import React, {Fragment, useRef, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import Loading from "../Loading/Loading";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import appUtility from "../../RestAPI/AppUtility";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";


export default function Report(){
    let state=useSelector((state)=> state);
    const ref=useRef();

    const [Division, setDivision]=useState([]);
    const [Circle, setCircle]=useState([]);
    const [DataCoEffeciant, setDataCoEffeciant]=useState([]);
    const [ColumnCoEfficient, setColumnCoEfficient]=useState([{}]);
    const [ColumnRevenueSummery, setColumnRevenueSummery]=useState([{}]);
    const [DataLength, setDatalength]=useState(0)
    const [MapStatus, setMapstatus]=useState()
    const[Id, setId]=useState()
    const[Bin, setBin]=useState()
    const[Name, setName]=useState()
    const[Mobile, setMobile]=useState()
    const[History, setHistory]=useState([]);
    const[RevenueSummery, setRevenueSummery]=useState([]);
    const[DataStatus, setDataStatus]=useState(false);
    const [showHistory, setShowHistory] = useState(false);

    const [DataVisitBin, setDataVisitBin]=useState([]);
    const [ColumnVisitBin, setColumnVisitBin]=useState([{}]);

    const [ShowBinVisit, setShowBinVisit] = useState(false);
    const handleCloseBinVisit = () => setShowBinVisit(false);
    const handleShowMapBinvisit = () => setShowBinVisit(true);

    const handleCloseHistory = () => setShowHistory(false);
    const handleShowHistory = () =>setShowHistory(true);
    const [showEntry, setShowEntry] = useState(false);
    const handleCloseEntry = () => setShowEntry(false);
    const handleShowEntry = () => setShowEntry(true);

    const [show, setShow] = useState(false);
    const [showRevenueSummery, setShowRevenueSummery] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showSMS, setShowSMS] = useState(false);
    const handleCloseSMS = () => setShowSMS(false);
    const handleShowSMS = () => setShowSMS(true);


    const handleCloseRevenueSummery = () => setShowRevenueSummery(false);
    const handleShowRevenueSummery = () => setShowRevenueSummery(true);



    const [showReportRevenueHistory, setShowReportRevenueHistory] = useState(false);

    const handleCloseReportRevenueHistory = () => setShowReportRevenueHistory(false);
    const handleShowReportRevenueHistory = () => setShowReportRevenueHistory(true);
    const [DataReportRevenueHistory, setDataReportRevenueHistory]=useState([]);
    const [ColumnReportRevenueHistory, setColumnReportRevenueHistory]=useState([{}]);




    const [DataDebt, setDataDebt]=useState([]);
    const [ColumnDebt, setColumnDebt]=useState([{}]);
    const [showDebtSummery, setShowDebtSummery] = useState(false);
    const handleCloseDebtSummery = () => setShowDebtSummery(false);
    const handleShowDebtSummery = () => setShowDebtSummery(true);

    const [showCall, setShowCall] = useState(false);
    const handleCloseCall = () => setShowCall(false);
    const handleShowCall = () => setShowCall(true);

    const [showElectricity, setShowElectricity] = useState(false);
    const handleCloseElectricity = () => setShowElectricity(false);
    const handleShowElectricity = () => setShowElectricity(true);

    const selectRow={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{

            setId(row['Id']);
            setBin(row['BIN']);
            setName(row['Name']);
            setMobile(row['Mobile']);
            setMapstatus(row['Lat']);
            handleShow();
        }
    }
    const getBIN=()=>{
        setDataStatus(true);
        setDatalength(0)
        const Category=document.getElementById("cmbBinCategory");
        const CategoryValue=Category.options[Category.selectedIndex].text;

        const Commi=document.getElementById("cmbBinCommi");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const Division=document.getElementById("cmbBinDivision");
        const DivisionValue=Division.options[Division.selectedIndex].text;


        const Circle=document.getElementById("cmbBinCircle");
        const CircleValue=Circle.options[Circle.selectedIndex].text;

        const Range=document.getElementById("cmbRange");
        const RangeValue=Range.options[Range.selectedIndex].text;

        const Items=document.getElementById("cmbItems");
        const ItemsValue=Items.options[Items.selectedIndex].text;
        const SmArea=document.getElementById("txtSmArea").value;

        const BinIvasStatus=document.getElementById("cmbBinIvasStatus");
        const BinIvasStatusValue=BinIvasStatus.options[BinIvasStatus.selectedIndex].text;

        const Flag=document.getElementById("cmbFlag");
        const OwnershipType=document.getElementById("cmbOwnershipType");
        const DebtStatus=document.getElementById("cmbDebtStatus");
        const MamlaStatus=document.getElementById("cmbMamlaStatus");
        const Bond=document.getElementById("cmbBond");


        const DataLimit=document.getElementById("cmbDataLimit");
        const DataLimitValue=DataLimit.options[DataLimit.selectedIndex].text;
        const SearchBin=document.getElementById("txtSearchBin").value;
        const SearchName=document.getElementById("txtSearchName").value;
        const SearchMobile=document.getElementById("txtSearchMobile").value;


        let getCommi=" ";
        let getDivision=" ";
        let getCircle=" ";
        let getCategory=" ";
        let getItems="";
        let getBin="";
        let getName="";
        let getMobile="";
        let getlimit ;
        let getFlag="";
        let getBinStatus="" ;

        let getSmArea=""
        let jsonObject;
        let getRange="";
        let getOwnershipType="";
        let getDebtStatus="";
        let getMamlaStatus="";
        let getBond="";

        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommi="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommi="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division"){if(Division.selectedIndex!=0){getDivision="And Division Like '%"+DivisionValue+"%'"}}
        else{getDivision="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle"){if(Circle.selectedIndex!=0){getCircle="And Circle Like '%"+CircleValue+"%'"}}
        else {getCircle="And Circle Like '%"+state.accessCir+"%'"}

        if(Range.selectedIndex!=0){getRange="And Range_Name ='"+RangeValue+"'"}
        if(BinIvasStatus.selectedIndex !=0){getBinStatus=" And BIN_Status ='"+BinIvasStatusValue+"' " }

        if(Flag.selectedIndex ==1){getFlag="And Flag >0"}
        if(Flag.selectedIndex ==2){getFlag="And Flag =0"}
        if(Flag.selectedIndex ==3){getFlag="And Flag =2"}
        if(Flag.selectedIndex ==4){getFlag="And Flag =3"}
        if(Flag.selectedIndex ==5){getFlag="And Flag =4"}

        if(DebtStatus.selectedIndex ==1){getDebtStatus="And Debt_Status =1"}
        if(DebtStatus.selectedIndex ==2){getDebtStatus="And Debt_Status =0"}

        if(MamlaStatus.selectedIndex ==1){getMamlaStatus="And Mamla_Status =1"}
        if(MamlaStatus.selectedIndex ==2){getMamlaStatus="And Mamla_Status =0"}

        if(OwnershipType.selectedIndex ==1){ getOwnershipType=" And Ownership_Type Like '%Limited%' "}
        if(OwnershipType.selectedIndex ==2){ getOwnershipType=" And Ownership_Type ='Proprietorship' "}

        if(Bond.selectedIndex ==1){ getBond=" And Bond_Licence =1 "}
        if(Bond.selectedIndex ==2){ getBond=" And Bond_Licence =0 "}

        if(Category.selectedIndex!=0){getCategory="And Economic_Activity Like '%"+CategoryValue+"%'  "}
        if(SmArea!=""){getCategory="And Manufacturing_Area Like '%"+SmArea+"%' OR Service_Area Like '%"+SmArea+"%' "}
        if(Items.selectedIndex!=0){getItems="And Category= '"+ItemsValue+"'"}

        if(SearchBin!=""){ getBin=" And BIN Like '%"+SearchBin+"%'"}
        if(SearchName!=""){ getName=" And Name Like '%"+SearchName+"%'"}
        if(SearchMobile!=""){ getMobile=" And Mobile Like '%"+SearchMobile+"%'"}




        if(DataLimit.selectedIndex!=0){getlimit=" LIMIT " +DataLimitValue
            jsonObject={"sql":" Select * from Bin where 1=1 "+getCommi+" "+getDivision+" "+getCircle+" "+getCategory+" "+getItems+"  "+getBin+" "+getName+" "+getSmArea+" "+getMobile+" "+getRange+" "+getBinStatus+" "+getFlag+" "+getOwnershipType+" "+getDebtStatus+" "+getMamlaStatus+" "+getBond+" "+getlimit+" "}

        }else{getlimit=""
            jsonObject={"sql":" Select count(BIN)AS 'Total BIN' from Bin where 1=1 "+getCommi+" "+getDivision+" "+getCircle+" "+getCategory+" "+getItems+"  "+getBin+" "+getName+" "+getSmArea+" "+getMobile+" "+getRange+" "+getBinStatus+"  "+getFlag+" "+getOwnershipType+" "+getDebtStatus+" "+getMamlaStatus+" "+getBond+" "+getlimit+" "}

        }

        setColumnCoEfficient([{}]);setDataCoEffeciant([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
           setDatalength(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatus(false)}else {
                await setColumnCoEfficient(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataCoEffeciant(result);
                    setDataStatus(false)
            }
        }).catch(error=>{ setDataStatus(false);});
    }
    const updateCategory=()=>{

        const ItemModel=document.getElementById("cmbItemsModel");
        const ItemModelValue=ItemModel.options[ItemModel.selectedIndex].text;

        if(ItemModel.selectedIndex==0){cogoToast.error("Please select Item Box")}else {
            RestClient.PostRequest(AppUrl.saveData, {"sql": "Update bin set Category='"+ItemModelValue+"' where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Data saved")

                } else {
                    cogoToast.error("Data not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }

    }
    const updateRange=()=>{

        const RangeNo=document.getElementById("cmbRangeOption");
        const RangeNoValue=RangeNo.options[RangeNo.selectedIndex].text;

        if(RangeNo.selectedIndex==0){cogoToast.error("Please select Range")}else {
            RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Range_Name='"+RangeNoValue+"' where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Range saved")

                } else {
                    cogoToast.error("Range not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }

    }
    const saveAudit=()=>{


            RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Audit=1 where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Audit saved")

                } else {
                    cogoToast.error("Audit not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });


    }
    const saveFlag=()=>{
        const FlagYes=document.getElementById("cmbFlagYes");

        if(FlagYes.selectedIndex==0){cogoToast.error("Please Select Flag Criteria")}else {
            RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Flag="+FlagYes.selectedIndex+" where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Flag saved")

                } else {
                    cogoToast.error("Flag not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }



    }
    const saveFlagNo=()=>{

            RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Flag=0 where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Flag has been removed")

                } else {
                    cogoToast.error("Flag has not been removed")
                }
            }).catch(error => {
                cogoToast.error(error)
            });




    }
    const updateBinStatus=()=>{


        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set BIN_Status='Shut Down' where Bin='"+Bin+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Status has been removed")

            } else {
                cogoToast.error("Status has not been removed")
            }
        }).catch(error => {
            cogoToast.error(error)
        });


    }
      const saveHistory=(status)=>{
          const TaskTitle=document.getElementById("cmbTaskTitle");
          const CategoryValue=TaskTitle.options[TaskTitle.selectedIndex].text;
        const history=document.getElementById("txtAreaDetailes").value;
          let jsonObject="";

          if(status==0){
              jsonObject={"sql": "Insert into bin_detailes (Id, BIN,Detailes,Entry_date,Entry_User)Values(NULL, '"+Bin+"','"+history+"','"+appUtility.getDate(new Date())+"','"+state.name+"') "};
              if(history==""){cogoToast.error("Please insert")}else{
                  RestClient.PostRequest(AppUrl.saveData, jsonObject).then(result => {
                      if (result == 1) {
                          cogoToast.success("Data saved")

                      } else {
                          cogoToast.error("Data not saved")
                      }
                  }).catch(error => {
                      cogoToast.error(error)
                  });}
          }else if(status==1){
              jsonObject={"sql": "Insert into Pending_Task (Id, BIN,Task,Start_Date,User)Values(NULL,'"+Bin+"','"+CategoryValue+"','"+appUtility.getDate(new Date())+"','"+state.name+"') "};

                  RestClient.PostRequest(AppUrl.saveData, jsonObject).then(result => {
                      if (result == 1) {
                          cogoToast.success("Data saved")

                      } else {
                          cogoToast.error("Data not saved")
                      }
                  }).catch(error => {
                      cogoToast.error(error)
                  });
          }



    }
    const getHistory=()=>{

       let jsonObject={"sql":" SELECT Id,Detailes FROM bin_detailes where BIN='"+Bin+"'  "};

        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                  setHistory(result);
                  setShowHistory(true);

            }
        }).catch(error=>{ });

    }
    const getRevenueSummery=(status)=>{


        let jsonObject="";
        if(status==0){ jsonObject  ={"sql":" SELECT * from Revenue_Summery "};}
        else if(status==1){
            const Circle17Column=document.getElementById("cmb17ColumnCircle");
            const Circle17ColumnValue=Circle17Column.options[Circle17Column.selectedIndex].text;

            const Month17Column=document.getElementById("cmb17ColumnMonth");
            const Month17ColumnValue=Month17Column.options[Month17Column.selectedIndex].text;

            let getCircle17Column="";
            let getMonth17Column="";

            if(Circle17Column.selectedIndex !=0){getCircle17Column=" And Circle ='"+Circle17ColumnValue+"' "}
            if(Month17Column.selectedIndex !=0){getMonth17Column=" And Month ='"+Month17ColumnValue+"' "}


            jsonObject  ={"sql":" SELECT * from revenue_17_Column where 1=1 "+getCircle17Column+" "+getMonth17Column+" "};}
        else if(status==2){
            jsonObject  ={"sql":" Select Id,Type,Month,Category,BIN_No,25_Month,25_Month_Upto,24_Month,24_Upto,Month_Diff,Upto_Diff,Month_Growth,Upto_Growth from Negative_Category_Revenue "};
        } else if(status==3){
            jsonObject  ={"sql":" Select Id,Circle,Range_name,BIN,Name,Category,Items,Month,25_Month,25_Month_Upto,24_Month,24_Month_Upto,Month_Diff,Upto_Diff,Month_Growth,Upto_Growth from negative_bin_view "};
        }




        setColumnRevenueSummery([{}]);setRevenueSummery([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");setDataStatus(false)}else {
                await setColumnRevenueSummery(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setRevenueSummery(result);

                handleShowRevenueSummery();

            }
        }).catch(error=>{ setDataStatus(false);});

    }
    const getIbasRevenue=()=>{
        const cmbIbasMonth=document.getElementById("cmbIbasRevenueMonth");
        const cmbIbasMonthValue=cmbIbasMonth.options[cmbIbasMonth.selectedIndex].text;

        const cmbIbasCircle=document.getElementById("cmbIbasRevenueCircle");
        const cmbIbasCircleValue=cmbIbasCircle.options[cmbIbasCircle.selectedIndex].text;

        let getCircle="";
        let getMonth="";

        if(cmbIbasCircle.selectedIndex!=0){getCircle=" And Circle ='"+cmbIbasCircleValue+"'"}
        if(cmbIbasMonth.selectedIndex!=0){getMonth=" And Month ='"+cmbIbasMonthValue+"'"}

        let jsonObject={"sql":" SELECT * from Ibas_Revenue where 1=1 "+getCircle+" "+getMonth+" "};
        setColumnRevenueSummery([{}]);setRevenueSummery([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");setDataStatus(false)}else {
                await setColumnRevenueSummery(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setRevenueSummery(result);

                handleShowRevenueSummery();

            }
        }).catch(error=>{ setDataStatus(false);});

    }

    const saveVisitData=()=>{
            navigator.geolocation.getCurrentPosition((position)=>{
                const latLang=position.coords.latitude+" , "+position.coords.longitude;

                RestClient.PostRequest(AppUrl.saveData, {"sql": " insert into visit_bin(Id,BIN,Name,Visit_Date,Lat_lang,officer,Lat,Lng,Entry_time)values(NULL,'"+Bin+"','"+Name+"','"+appUtility.getDate(new Date())+"','"+latLang+"','"+state.name+"',"+position.coords.latitude+" ,"+position.coords.longitude+", NOW() + INTERVAL 6 HOUR  ) "}).then(result => {
                    if (result == 1) {
                        cogoToast.success("Map saved")

                    } else {
                        cogoToast.error("Map not saved")
                    }
                }).catch(error => {
                    cogoToast.error(error)
                });
            })

        }
    const saveCallData=()=>{

        const CallComments=document.getElementById("txtCallComments").value;

        if(CallComments==""){cogoToast.error("Please insert calling comments")}else {
            RestClient.PostRequest(AppUrl.saveData, {"sql": " insert into Call_data(Id,BIN,Comments,Caller,Call_Date)values(NULL,'"+Bin+"','"+CallComments+"','"+state.name+"','"+appUtility.getDate(new Date())+"') "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Call Data saved")

                } else {
                    cogoToast.error("Call Data not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });}

    }
    const saveSMSData=()=>{

        const sms=document.getElementById("txtSms").value;


            RestClient.PostRequest(AppUrl.saveData, {"sql": " insert into sms_data(Id,BIN,SMS,SMS_Sender,SMS_Date)values(NULL,'"+Bin+"','"+sms+"','"+state.name+"','"+appUtility.getDate(new Date())+"') "}).then(result => {
                if (result == 1) {
                    cogoToast.success("SMS Data saved")

                } else {
                    cogoToast.error("SMS Data not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });

    }
    const saveElectricityData=()=>{
        const ElectricityYear=document.getElementById("cmbElectricityYear");
        const ElectricityYearValue=ElectricityYear.options[ElectricityYear.selectedIndex].text;

        const ElectricityMonth=document.getElementById("cmbElectricityMonth");
        const ElectricityMonthValue=ElectricityMonth.options[ElectricityMonth.selectedIndex].text;

        const ElectricityUnit=document.getElementById("txtElectricityUnit").value;
        const ElectricityPrice=document.getElementById("txtElectricityPrice").value;
        let jsonObject={"sql": " insert into Electricity_data(Id,BIN,Bill_Year,Bill_Month,Consumption_Unit,Unit_Price,Entry_Officer,Entry_Date)values(NULL,'"+Bin+"',"+ElectricityYearValue+",'"+ElectricityMonthValue+"',"+ElectricityUnit+","+ElectricityPrice+",'"+state.name+"','"+appUtility.getDate(new Date())+"') "};
            if(ElectricityYear.selectedIndex==0){cogoToast.error("Please select Year")}else{
            if(ElectricityMonth.selectedIndex==0){cogoToast.error("Please select Month")}else{
            if(ElectricityUnit==""){cogoToast.error("Please Insert Unit")}else{
            if(ElectricityPrice==""){cogoToast.error("Please Insert Price")}else{


        RestClient.PostRequest(AppUrl.saveData,jsonObject ).then(result => {
            if (result == 1) {
                cogoToast.success("Electircity Data saved")

            } else {
                cogoToast.error("Electircity Data not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });
            }}}}

    }
    const saveMapData=()=>{
        navigator.geolocation.getCurrentPosition((position)=>{

            RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Lat="+position.coords.latitude+", Lang="+position.coords.longitude+" where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Map Data saved")

                } else {
                    cogoToast.error("Map Data not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        })

    }


    const getVisitHistory=()=>{

        let jsonObject={"sql":" SELECT Officer,Entry_time As Visit_Date,Lat_lang As Map_Cords from Visit_BIN where BIN='"+Bin+"' "};
        setColumnVisitBin([{}]);setDataVisitBin([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnVisitBin(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataVisitBin(result);

                handleShowMapBinvisit();

            }
        }).catch(error=>{ });

    }


    const getRevenueHistory=(status)=>{
        let jsonObject="";
                    if(status==0){
                        jsonObject={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25,January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26" +
                                ",(July_24+August_24+September_24+October_24+November_24+December_24+January_25+February_25+March_25+April_25+May_25+June_25)As Total_Last_Year," +
                                "(July_25+August_25+September_25+October_25+November_25+December_25+January_26+February_26+March_26+April_26+May_26+June_26)As Total_Upto FROM nbr.revenue_25_26_view where BIN='"+Bin+"' "};

                    }else if(status==1){
                        jsonObject={"sql":" select FY,Month,round(Closing_balance_vat/Deposited_vat,1)AS Balance_TR,round(Total_Payable_VAT/Deposited_vat,1)AS Payable_TR,`Deposite_%`,`Rebate_%`,`Decreasing_%`,Total_Sales_Value,Total_Payable_Vat,Total_Payable_SD,Total_Input_Tax_Credit_Value,Total_Input_Tax_Credit_VAT,Increasing_Adjustment,Decreasing_Adjustment,Net_Payable_VAT,Net_Payable_SD,Deposited_VAT,Deposited_SD,Closing_Balance_VAT,Closing_Balance_SD,VDS_Increasing,VDS_Decreasing,AT_Paid from Revenue_Analyse_View where BIN='"+Bin+"' order by Month_Code Desc "};

                    }else if(status==2){
                        jsonObject={"sql":" SELECT HSCODE,Description As Description_Of_Goods,Supply_Qty,Supply_Unit As Unit,Rm_Price,Addition_Price,Addition_Parcentage AS 'Add_%',Total_Price,Entry_Date As 'Effect_Date',DATEDIFF(CURDATE(),Entry_Date) AS Total_Days,Entry_Date,Status,Sale_Category,Comments As Comments_for_goods FROM `Co_Efficient` where BIN='"+Bin+"' "};

                    }else if(status==3){
                        jsonObject={"sql":" SELECT Court,Mamla_No,Mamla_Year,Mamla_Type,Amount,Status from Mamla where BIN='"+Bin+"' "};

                    } else if(status==4){
                        jsonObject={"sql":" SELECT Id, Reasons from negative_bin where BIN='"+Bin+"' "};

                        } else if(status==5){
                        jsonObject={"sql":" SELECT Caller,Call_Date,Comments from Call_Data where BIN='"+Bin+"' "};

                    }else if(status==6){
                        jsonObject={"sql":" SELECT Bill_Year,Bill_Month,Consumption_Unit As Unit,Unit_Price As Price,Entry_Officer,Entry_Date from Electricity_Data where BIN='"+Bin+"' "};

                    }else if(status==7){
                        jsonObject={"sql":" SELECT Id, SMS,SMS_Sender,SMS_Date from sms_Data where BIN='"+Bin+"' "};

                    }

            setColumnReportRevenueHistory([{}]);setDataReportRevenueHistory([])
            RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

                if(result==""){cogoToast.error("Data not found");}else {
                    await setColumnReportRevenueHistory(
                        Object.keys(result[0]).map((k) => {
                            return {dataField: k, text: k, sort: true}
                        })
                    )
                    await setDataReportRevenueHistory(result);

                    handleShowReportRevenueHistory();

                }
            }).catch(error=>{ });

        }



    const getDebtHistory=()=>{

        let jsonObject={"sql":" SELECT * FROM debt_report where BIN='"+Bin+"' "};
        setColumnDebt([{}]);setDataDebt([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnDebt(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataDebt(result);

                handleShowDebtSummery();

            }
        }).catch(error=>{ });

    }

    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinCommi"
                                            onChange={()=>{
                                                setDivision([]);
                                                setCircle([]);
                                                const e = document.getElementById("cmbBinCommi");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivision(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                <select className="float-start w-100 customfontsize" id="cmbBinDivision"
                                        onChange={()=>{
                                            setCircle([])
                                            const e = document.getElementById("cmbBinDivision");
                                            const value = e.options[e.selectedIndex].value;
                                            const dt=state.circle.filter(x => x.Division_Id==value);
                                            setCircle(dt)


                                        }}
                                >
                                    <option >All Division</option>

                                    {
                                        Division.map((ctr,index)=>{
                                            return (
                                                <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                            )
                                        })

                                    }
                                </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                <select className="float-start w-100 customfontsize" id="cmbBinCircle" >
                                    <option >All Circle</option>

                                    {
                                        Circle.map((ctr,index)=>{
                                            return (
                                                <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                            )
                                        })

                                    }


                                </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbRange"  >
                                        <option >All Range</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                        <option >No Range</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Category</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinCategory"  >
                                        <option >All Category</option>
                                        <option >Manufacturing</option>
                                        <option >Services</option>
                                        <option >Other</option>
                                        <option >Imports</option>
                                        <option >Exports</option>
                                        <option >Construction</option>
                                        <option >Wholesale</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">SM_Area</label></Col>
                                <Col lg={9} xs={8}>
                                    <input type="text" className="w-100" id="txtSmArea"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Items</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbItems"  >
                                        <option value="0">All Items</option>
                                        {
                                            state.category.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }

                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Status</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbBinIvasStatus"  >
                                        <option >All</option>
                                        <option >Active</option>
                                        <option >Cancelled</option>
                                        <option >Suspended</option>
                                        <option >Locked</option>
                                        <option >Shut Down</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BOND</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbBond"  >
                                        <option >Both</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BIN</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchBin"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchName"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Mobile</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchMobile"/>
                                </Col>

                            </Row>


                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Flag</label></Col>
                                <Col lg={9}xs={8}>
                                    <select className="float-start w-100 customfontsize"  id="cmbFlag">
                                        <option>All</option>
                                        <option>Yes</option>
                                        <option>No</option>
                                        <option>High</option>
                                        <option>Medium</option>
                                        <option>Highest</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Type</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbOwnershipType"  >
                                        <option >All</option>
                                        <option >Limited</option>
                                        <option >Propritorship</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Mamla</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbMamlaStatus"  >
                                        <option >All</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Debt</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbDebtStatus"  >
                                        <option >All</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimit"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getBIN}>Search</button>
                                </Col>


                            </Row>



                        </div>
                    </Col>

                    <Col lg={9}>

                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">
                            {
                               DataStatus? <LoadingText/>
                               :<BootstrapTable ref={ref} selectRow={selectRow} id="BinTable" keyField='Id' data={DataCoEffeciant} columns={ColumnCoEfficient}></BootstrapTable>


                            }
                              </div>
                        <di>
                            <label className="text-danger">Data found: {DataLength}</label>
                            <Row className="mb-2">
                                <Col lg={3}> <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button bg-primary  text-white" table="BinTable" filename="BIN Detailes Report" sheet="tablexls" buttonText="Download Excel"/>
                                </Col>
                                <Col lg={1}><Button className="bg-danger" onClick={()=>getRevenueSummery(2)}>Negative Category</Button></Col>
                                <Col lg={1}><Button className="bg-danger" onClick={()=>getRevenueSummery(3)}>Negative BIN</Button></Col>
                                <Col lg={3}> <Button onClick={()=>getRevenueSummery(0)}>Revenue Summery</Button></Col>
                                <Col lg={4}>
                                    <div>
                                        <Row>
                                            <Col lg={6}> <Button onClick={getIbasRevenue}>IBAS Revenue</Button> </Col>
                                            <Col lg={3}> <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbIbasRevenueCircle"  >
                                                <option >All</option>
                                                <option >Ashulia Circle</option>
                                                <option >Dhamsona Circle</option>
                                                <option >Hemayetpur Circle</option>
                                                <option >Yarpur Circle</option>
                                                <option >Savar Circle</option>
                                                <option >Rajashon Circle</option>
                                            </select>
                                            </Col>
                                            <Col lg={3}> <select  className="float-start w-100 customfontsize" id="cmbIbasRevenueMonth"  >
                                                <option >All</option>
                                                <option >July</option>
                                                <option >August</option>
                                                <option >September</option>
                                                <option >October</option>
                                                <option >November</option>
                                                <option >December</option>
                                                <option >January</option>
                                                <option >February</option>
                                                <option >March</option>
                                                <option >April</option>
                                                <option >May</option>
                                                <option >June</option>
                                            </select>
                                            </Col>
                                        </Row>


                                    </div>


                                </Col>


                            </Row>
                        </di>

                    </Col>


                </Row>


            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{Name}</Modal.Title>


                </Modal.Header>
                <Modal.Body>
                    <div className="flex-column">

                        <select className="float-start me-2 w-50 customfontsize" id="cmbItemsModel"  >
                            <option value="0">All Items</option>
                            {
                                state.category.map((ctr,index)=>{
                                    return (
                                        <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                    )
                                })

                            }
                        </select>

                        <Button variant="primary" onClick={updateCategory}>
                            Save
                        </Button>
                        <hr/>
                        <select className="float-start me-2 w-50 customfontsize" id="cmbRangeOption"  >
                            <option >All Range</option>
                            <option >Range-1</option>
                            <option >Range-2</option>
                            <option >Range-3</option>
                            <option >Range-4</option>
                            <option >Range-5</option>
                            <option >Range-6</option>
                            <option >Range-7</option>
                        </select>
                        <Button variant="primary" onClick={updateRange}>Save</Button>
                    </div>
                    <hr/>
                    <div className="w-75">
                        <Button className="" variant="danger" onClick={()=>getRevenueHistory(0)} >Revenue Monthly</Button> <label>__</label>
                        <Button className="" variant="primary" onClick={()=>getRevenueHistory(1)} >Revenue Analysis</Button>
                    </div><hr className="mb-1"/>
                    <div className="w-75">

                        <Button className="" variant="danger" onClick={()=>getRevenueHistory(4)} >Negative history</Button> <label>____</label>
                        <Button className="" variant="primary" onClick={()=>getRevenueHistory(2)} >4.3</Button>
                    </div><hr className="mb-1"/>

                    <div className="w-75">
                        <Button className="" variant="danger" onClick={()=>getRevenueHistory(3)} >Mamla History</Button><label>_______</label>
                        <Button className="" variant="primary" onClick={getDebtHistory} >Debt History</Button>
                    </div><hr className="mb-1"/>
                    <div className="w-75"><Button className="" variant="danger" onClick={saveAudit} >Audit ? Yes</Button><label>___________</label>
                        {
                            MapStatus >0?<Button className="" variant="primary" disabled={true} onClick={saveMapData} >Map Already Added</Button>
                                :<Button className="" disabled={false} variant="primary" onClick={saveMapData} >Add Map Location</Button>
                        }
                    </div><hr className="mb-1"/>

                    <div className="w-75">
                        <Button className="" variant="danger" onClick={saveVisitData} >Visit Factory?</Button><label>________</label>
                        <Button className="" variant="primary" onClick={getVisitHistory} >Visit Log</Button>
                    </div><hr className="mb-1"/>

                    <div className="w-75">
                        <Button  variant="danger" onClick={()=>{handleShowElectricity();handleClose()}}>Electricity Insert</Button><label>____</label>
                        <Button variant="primary" onClick={()=>getRevenueHistory(6)}>Electricity History</Button>

                    </div>
                    <div className="w-75"><hr className="mb-1"/>
                        <Button variant="danger" onClick={getHistory}>Show History</Button><label>_______</label>
                        <Button variant="primary" onClick={()=>{handleShowEntry();handleClose()}}>Entry History</Button>
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <Button  variant="danger" onClick={()=>{handleShowCall();handleClose()}}>Call</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistory(5)}>Call Log</Button>
                    <Button  variant="danger" onClick={()=>{handleShowSMS();handleClose()}}>SMS</Button>
                    <Button  variant="primary" onClick={()=>getRevenueHistory(7)}>SMS Log</Button>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>



                </Modal.Footer>
            </Modal>

            <Modal show={showSMS} onHide={handleCloseSMS}>
                <Modal.Header closeButton>
                    <Modal.Title> <label className="text-primary">New SMS send</label> </Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    <label>{Name}</label>
                    <hr/>
                    <label className="text-danger">Mobile No :</label>
                    <input type="text" defaultValue={Mobile} id="txtSmsNumber"/>
                    <hr/>

                    <textarea id="txtSms" placeholder="Please write your sms here. Maximum 120 letters" rows={10} className="w-100 h-50"></textarea>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="float-end" variant="success" onClick={()=>{
                        const sms=document.getElementById("txtSms").value;
                        const smsNumber=document.getElementById("txtSmsNumber").value;
                        if(smsNumber==""){cogoToast.error("Please insert send Number")}else{
                            if(sms==""){cogoToast.error("Please write sms in the box")}else{
                                appUtility.sendSMS(sms,smsNumber);saveSMSData();
                            }
                        }

                    }
                    } >
                        Send sms
                    </Button>

                    <Button variant="danger" onClick={handleCloseSMS}>
                        Close
                    </Button>




                </Modal.Footer>


            </Modal>
            <Modal show={showEntry} onHide={handleCloseEntry}>
                <Modal.Header closeButton>

                    <label>History entry form</label>

                </Modal.Header>
                <Modal.Body>
                <textarea className="text-area" id="txtAreaDetailes"></textarea>
                    <hr/>
                    <Button variant="success" onClick={saveFlag} >
                        Flag ? Yes
                    </Button>
                    <select id="cmbFlagYes">
                        <option>Select</option>
                        <option>Low</option>
                        <option>High</option>
                        <option>Medium</option>
                        <option>Highest</option>
                    </select>
                    <hr/>



                </Modal.Body>
                <Modal.Footer>

                    <Button variant="primary" onClick={updateBinStatus}>
                        Shut Down
                    </Button>
                    <Button variant="danger" onClick={()=>saveHistory(0)} >
                        Save History
                    </Button>
                    <Button variant="danger" onClick={()=>saveHistory(1)} >
                        Mark Pending
                    </Button>
                    <select id="cmbTaskTitle">
                        <option>Other</option>
                        <option>Preventive</option>
                        <option>Check Return</option>
                        <option>Check 4.3</option>
                        <option>Check Import</option>
                    </select>
                    <Button variant="primary" onClick={saveFlagNo} >
                        Flag ? No
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showHistory} onHide={handleCloseHistory}>
                <Modal.Header closeButton>

                    <label>Detailes History</label>

                </Modal.Header>
                <Modal.Body>
                    {
                        History.map((ctr,index)=>{
                            return (
                              <div> <label>{ctr.Detailes}</label>
                                <hr/>
                              </div>
                            )
                        })
                    }

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseHistory}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>



            <Modal show={showRevenueSummery} onHide={handleCloseRevenueSummery} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>Revenue Summery :</label>
                    <div>
                        <Row>
                            <Col lg={3}> <select defaultValue={100} className="float-start w-100 customfontsize" id="cmb17ColumnCircle"  >
                                <option >All</option>
                                <option >Ashulia Circle</option>
                                <option >Dhamsona Circle</option>
                                <option >Hemayetpur Circle</option>
                                <option >Yarpur Circle</option>
                                <option >Savar Circle</option>
                                <option >Rajashon Circle</option>
                            </select>
                            </Col>
                            <Col lg={3}> <select defaultValue={100} className="float-start w-100 customfontsize" id="cmb17ColumnMonth"  >
                                <option >All</option>
                                <option >July</option>
                                <option >August</option>
                                <option >September</option>
                                <option >October</option>
                                <option >November</option>
                                <option >December</option>
                                <option >January</option>
                                <option >February</option>
                                <option >March</option>
                                <option >April</option>
                                <option >May</option>
                                <option >June</option>
                            </select>
                            </Col>
                            <Col lg={6}>
                                <Button variant="danger" onClick={()=>getRevenueSummery(1)} >Get 17 Column</Button>
                            </Col>
                        </Row>


                    </div>


                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                    {
                        DataStatus? <LoadingText/>
                            :<BootstrapTable  keyField='Month'  data={RevenueSummery} columns={ColumnRevenueSummery}></BootstrapTable>


                    }
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseRevenueSummery}>
                        Close
                    </Button>



                </Modal.Footer>
            </Modal>

            <Modal show={ShowBinVisit} onHide={handleCloseBinVisit} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>Visit Summery</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataVisitBin} columns={ColumnVisitBin}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseBinVisit}>
                        Close
                    </Button>



                </Modal.Footer>
            </Modal>

            <Modal show={showReportRevenueHistory} onHide={handleCloseReportRevenueHistory} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{Name}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataReportRevenueHistory} columns={ColumnReportRevenueHistory}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseReportRevenueHistory}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>


            <Modal show={showDebtSummery} onHide={handleCloseDebtSummery} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>Debt Summery</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataDebt} columns={ColumnDebt}></BootstrapTable>}

                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseDebtSummery}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>


            <Modal show={showCall} onHide={handleCloseCall} >
                <Modal.Header closeButton>

                    <label>{Name}</label>

                </Modal.Header>
                <Modal.Body >
                    <label>Insert Call history</label><hr/>
                    <label>Comments:</label>
                        <input className="w-100" type="text" id="txtCallComments"/>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseCall}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={saveCallData}>
                        Save
                    </Button>

                </Modal.Footer>
            </Modal>
            <Modal show={showElectricity} onHide={handleCloseElectricity} >
                <Modal.Header closeButton>

                    <label>{Name}</label>

                </Modal.Header>
                <Modal.Body >
                    <label>Electricity Bill Entry</label><hr/>
                    <div>
                        <label>Year:</label>
                        <select  className="w-50 customfontsize" id="cmbElectricityYear"  >
                            <option >ALl</option>
                            <option >2026</option>
                            <option >2025</option>
                            <option >2024</option>
                            <option >2023</option>
                        </select>
                    </div><hr/>
                    <div>
                        <label>Month:</label>
                        <select  className="w-50 customfontsize" id="cmbElectricityMonth"  >
                            <option >All</option>
                            <option >July</option>
                            <option >August</option>
                            <option >September</option>
                            <option >October</option>
                            <option >November</option>
                            <option >December</option>
                            <option >January</option>
                            <option >February</option>
                            <option >March</option>
                            <option >April</option>
                            <option >May</option>
                            <option >June</option>
                        </select>
                    </div><hr/>
                    <div>
                        <label>Unit:</label>
                        <input type="text" id="txtElectricityUnit"/><label>write in number</label>
                    </div><hr/>
                    <div>
                        <label>Price:</label>
                        <input type="text" id="txtElectricityPrice"/><label>write in number</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseElectricity}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={saveElectricityData} >
                        Save
                    </Button>

                </Modal.Footer>
            </Modal>






        </Fragment>

    )
}
